import React from "react";
import { createusers } from "../api/Users";
import Swal from "sweetalert2";

const Register = () => {
  const [data, setData] = React.useState({
    name: "",
    email: "",
    phone_no: "",
    password: "",
    address: "",
    isAgree: false,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const response = createusers(data);
    response
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          Swal.fire({
            title: "User resgistered successfully!",
            text: "You have successfully created a inquiry details!",
            icon: "success",
            draggable: true,
            timer: 1000,
          });
          setData({
            name: "",
            email: "",
            phone_no: "",
            password: "",
            address: "",
            isAgree: false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <section id="register" className="py-5">
        <div className="container">
          <h1 className="text-center">Register form</h1>
          <div className="row justify-content-center align-items-center">
            <div className="col-sm-12 col-md-6 col-lg-6">
              <img
                src="/assets/images/register-bg.jpg"
                alt="logo"
                width="100%"
              />
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6">
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="exampleInputName1">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={data.name}
                    onChange={(e) =>
                      setData({
                        ...data,
                        name: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputPhone">Phone number</label>
                  <input
                    type="text"
                    className="form-control"
                    name="phone_no"
                    value={data.phone_no}
                    onChange={(e) =>
                      setData({
                        ...data,
                        phone_no: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Email address</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={data.email}
                    onChange={(e) =>
                      setData({
                        ...data,
                        email: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputPassword1">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    name="password"
                    value={data.password}
                    onChange={(e) =>
                      setData({
                        ...data,
                        password: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="address">Address</label>
                  <textarea
                    className="form-control"
                    id="address"
                    rows="3"
                    name="address"
                    value={data.address}
                    onChange={(e) =>
                      setData({ ...data, address: e.target.value })
                    }
                  ></textarea>
                </div>
                <div className="form-group form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    name="isAgree"
                    id="exampleCheck1"
                    value={data.isAgree}
                    onChange={(e) =>
                      setData({
                        ...data,
                        isAgree: e.target.checked,
                      })
                    }
                  />
                  <label className="form-check-label" htmlFor="exampleCheck1">
                    Check me out
                  </label>
                </div>
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Register;
